// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1vyn8","loaderOuter":"PageOverlayLoader_loaderOuter__2QXDF"};